// extracted by extract-css-chunks-webpack-plugin
module.exports = {"EmptyArea":"EmptyArea_1zsfQ_v16-5-1","VerticalNav":"VerticalNav_qU-wq_v16-5-1","Title":"Title_2J6CA_v16-5-1"};